import { HostType } from '@/types/enums';
import { IHost } from '@/types/models';
import { HOST_DOMAIN_HONGKONG, HOST_DOMAIN_MAINLAND } from '@/const';
import getHostUrl from './getHostUrl';
import getHostUniqueName from './getHostUniqueName';

function getHostConnections(
  host: IHost,
  isHongKong: boolean,
  securityKey: string,
  ftpPassword: string,
  databaseHost: string,
  databaseUser: string,
  databasePassword: string,
  databaseName: string,
) {
  const hostDomain = isHongKong ? HOST_DOMAIN_HONGKONG : HOST_DOMAIN_MAINLAND;
  const hostUrl = getHostUrl(host.hostName, host.nodeName, isHongKong);
  const uniqueName = getHostUniqueName(host);
  const connections = [];
  connections.push({
    name: '实例Id',
    description: uniqueName,
    docUrl: '',
  });
  if (host.nickName) {
    connections.push({
      name: '实例名称',
      description: `${host.nickName}`,
      docUrl: '',
    });
  }
  if (isHongKong) {
    connections.push({
      name: '服务器位置',
      description: '香港',
      docUrl: '',
    });
  }
  connections.push({
    name: '访问地址',
    description: `<a href="${getHostUrl(
      host.hostName,
      host.nodeName,
      isHongKong,
    )}" class="el-link el-link--primary" target="_blank">${hostUrl}</a>`,
    docUrl: '',
  });
  connections.push({
    name: 'SSCMS 管理后台',
    description: `<a href="${hostUrl}/ss-admin/" class="el-link el-link--primary" target="_blank">${hostUrl}/ss-admin/</a>`,
    docUrl: '',
  });
  connections.push({
    name: 'SecurityKey',
    description: securityKey,
    docUrl: '',
  });
  connections.push({
    name: 'DNS 域名解析',
    description: `请修改域名 DNS，增加域名 CNAME 解析至：<strong>${host.nodeName}.${hostDomain}</strong>`,
    docUrl: 'https://sscms.com/docs/v7/host/essential/domain.html',
  });
  if (host.hostType !== HostType.Starter) {
    connections.push({
      name: 'SFTP',
      description: `
      主机：<strong>${host.nodeName}.${hostDomain}</strong><br />
      用户名：<strong>${uniqueName}</strong><br />
      密码：<strong>${ftpPassword}</strong>`,
      docUrl: 'https://sscms.com/docs/v7/host/essential/sftp.html',
    });
  }

  if (host.hostType === HostType.Professional) {
    connections.push({
      name: '数据库连接',
      description: `
      数据库类型：<strong>MySQL</strong><br />
      数据库主机：<strong>${databaseHost}</strong><br />
      用户名：<strong>${databaseUser}</strong><br />
      密码：<strong>${databasePassword}</strong><br />
      数据库名称：<strong>${databaseName}</strong>`,
      docUrl: 'https://sscms.com/docs/v7/host/essential/database.html',
    });
  }

  return connections;
}

export default getHostConnections;
